import { Component, Input } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { HomePage } from "../../home/home";
import { Globals } from '../../../globals';
import { SearchServices } from '../../services/searchs';
import { TPVServices } from '../../tpv/services';
import { NativeStorage } from '@ionic-native/native-storage';
import { PopupInfoPage } from '../popups/popup-info/popup-info';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationPage } from '../../configuration/configuration';

/**
 * Generated class for the PartialPageTitlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-partial-page-title',
  templateUrl: 'partial-page-title.html',
})
export class PartialPageTitlePage {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() marginTop: string;
  @Input() paddingLeft: string;
  @Input() section: string;
  sections = ['cartas', 'menus', 'combos', 'reservas', 'articles', 'pedidos', 'stock', 'ingredients', 'deno', 'inex', 'customers', 'sales', 'pos', 'config', 'analytics'];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public searchServices: SearchServices,
    public tpvServices: TPVServices,
    private nativeStorage: NativeStorage,
    public modalCtrl: ModalController,
    public translate: TranslateService) {

  }

  public onBack() {
    //Vaciamos el buscador de clientes
    this.searchServices.customer_data = '';

    if (this.navCtrl.canGoBack()) {
      this.navCtrl.pop();
    } else {
      if (this.navCtrl.getActive().name.toLowerCase().includes('configuration') && this.navCtrl.getActive().name != 'ConfigurationCloseCashViewPage') {
        this.navCtrl.setRoot(ConfigurationPage);
      } else {
        this.navCtrl.setRoot(HomePage);
      }
    }
  }

  changeNetworkState(state) {
    this.globals.connection_manual = state;

    if (this.globals.connection_manual) {
      this.openOfflineWarning();
      this.globals.connection = false;
      this.nativeStorage.getItem('offline_number')
        .then(
          data => { },
          error => {
            //no tiene crear
            this.nativeStorage.setItem('offline_number', 0)
              .then(() => { }, error => { });
          }
        );
    } else {
      this.globals.connection = true;
    }
  }

  openOfflineInfo() {
    let profileModal = this.modalCtrl.create(PopupInfoPage, { origin: 'offline', type: 'info' });
    profileModal.onDidDismiss(data => {
    });
    profileModal.present();
  }

  openOfflineWarning() {
    let profileModal = this.modalCtrl.create(PopupInfoPage, { origin: 'offline', type: 'warning' });
    profileModal.onDidDismiss(data => {
    });
    profileModal.present();
  }



}



// WEBPACK FOOTER //
// ./src/pages/components/partial-page-title/partial-page-title.ts